import { TableRowDisplayEvent } from "@mcleod/components/src/events/TableRowDisplayEvent";
import { AutogenLayoutTariffLineItemData } from "./autogen/AutogenLayoutTariffLineItemData";
import { TariffManagementUtil } from "./TariffManagementUtil";

export class TariffLineItemData extends AutogenLayoutTariffLineItemData {

    tableTLIDataOnRowDisplay(event: TableRowDisplayEvent) {
        TariffManagementUtil.tableRowDisplayLogic(event);
    }
}
